import { styled } from '@mui/system';
import { COLORS } from './colors';

export const MetricSectionTitleContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  columnGap: '16px',
});

interface MetricSectionTitleColorCodeProps {
  color: 'best' | 'middle' | 'worst';
}
export const MetricSectionTitleColorCode = styled('div', {
  shouldForwardProp: (prop) => prop !== 'color',
})<MetricSectionTitleColorCodeProps>(({ color }) => ({
  width: '32px',
  height: '32px',
  borderRadius: '100%',
  backgroundColor: COLORS.color_blind_friendly[color],
}));

export const MetricSectionTitlePrognosisTooltip = styled('div')({
  '& > strong': {
    display: 'block',
    fontWeight: 700,
    fontSize: '14px',
  },
  '& > small': {
    display: 'block',
  },
  '& > ul': {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: 0,
    marginBottom: '10px',
    marginTop: '10px',
    listStyleType: 'none',
    '& > li': {
      display: 'flex',
      flexDirection: 'row',
      columnGap: '5px',
      fontSize: '12px',
      alignItems: 'center',
      '& > span': {
        display: 'block',
        width: '12px',
        height: '12px',
        borderRadius: '100%',
      },
    },
  },
});
